import classNames from 'clsx';
import React from 'react';

import LazyImage from '@swf/components/LazyImage/LazyImage';

import Loader from '../Loader/Loader';

import styles from './Image.scss';
import Placeholder from './assets/placeholder.svg';

interface Props {
  imageUrl?: string;
  imageByteArray?: string;
  className?: string;
  loaderClassName?: string;
  alt?: string;
  dataTestId?: string;
  fallback?: React.ReactNode;
  loader?: React.ReactNode;
  dimensions?: {
    width: number;
    height: number;
  };
}

const DefaultFallback: React.FC<Props> = ({ className, ...rest }) => (
  <Placeholder className={classNames(styles.fallback, className, 'game-tile-fallback')} {...rest} />
);
const DefaultLoader: React.FC = () => (
  <div className={styles.loader}>
    <Loader loading />
  </div>
);

const Image: React.FC<Props> = ({
  imageUrl,
  imageByteArray,
  className,
  alt,
  dataTestId,
  fallback = <DefaultFallback />,
  loader = <DefaultLoader />,
  dimensions = {}
}) =>
  imageUrl ? (
    <LazyImage
      fallback={fallback}
      src={imageUrl}
      className={classNames(styles.image, className)}
      loader={loader}
      alt={alt}
      data-testid={dataTestId}
      {...dimensions}
    />
  ) : imageByteArray ? (
    <img
      src={`data:image/jpeg;base64,${imageByteArray}`}
      className={className}
      alt={alt}
      data-testid={dataTestId}
      {...dimensions}
    />
  ) : (
    (fallback as React.ReactElement)
  );
export default Image;
